import React, { Component, createRef, Fragment } from "react";
import { isEqual } from "lodash";
import "component/list/TableList/styles.scss";
import translations from "translations";

class TableList extends Component {
  constructor(props) {
    super(props);
    this.endRef = createRef();

    this.state = {
      games: null,
      showMore: false,
      headers: null,
      totalColumn: 5,
    };
  }

  initObserver() {
    if (
      "IntersectionObserver" in window &&
      "IntersectionObserverEntry" in window &&
      "intersectionRatio" in window.IntersectionObserverEntry.prototype
    ) {
      let observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              if (this.endRef.current) {
                this.props.onReachEnd();
              }
            }
          });
        },
        {
          rootMargin: "0px 0px 0px 0px",
          threshold: 0.1,
        }
      );
      observer.observe(this.endRef.current);
    } else {
    }
  }

  scrollIntoView(elem) {
    setTimeout(() => {
      elem.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      });
    }, 50);
  }

  componentDidMount() {
    this.initObserver();
    if (this.props.totalColumn) {
      this.setState({
        totalColumn: this.props.totalColumn,
      });
    }
  }

  componentDidUpdate(prevProps) {
    if (!isEqual(prevProps.list, this.props.list) && this.props.list) {
      const items = this.props.list ? this.props.list.get("items") : null;
      let totalColumn = this.state.totalColumn;

      try {
        totalColumn = items.get(0).size;
      } catch (err) {}
      const headers =
        items && items.toJSON().length > 0
          ? Object.keys(items.toJSON()[0])
          : null;

      this.setState({
        headers,
        totalColumn,
      });
    }
  }

  render() {
    const items = this.props.list ? this.props.list.get("items") : null;

    if (this.props.listComplete && !items) {
      return <div className="text-center">{translations("thereIsNoData")}</div>;
    }

    return (
      <div className="table-list-component">
        <table className="table-list">
          <thead>
            {!this.state.headers && !this.props.listComplete && (
              <tr>
                {[...Array(this.state.totalColumn)].map((item, key) => {
                  if (this.props.setHeaderSkeleton) {
                    return this.props.setHeaderSkeleton(key);
                  }

                  return (
                    <th key={key}>
                      <span className="dummy">loading</span>
                    </th>
                  );
                })}
              </tr>
            )}
            {this.state.headers && (
              <tr>
                {this.state.headers.map((header, key) => (
                  <th
                    key={key}
                    onClick={() => {
                      if (this.props.onSort) {
                        this.props.onSort(header);
                      }
                    }}
                  >
                    {!this.props.setLabel && <span>{header}</span>}
                    {this.props.setLabel && (
                      <span>{this.props.setLabel(header)}</span>
                    )}
                  </th>
                ))}
              </tr>
            )}
          </thead>

          <tbody>
            {items &&
              items.map((item, key) => {
                const keys = Object.keys(items.toJSON()[key]);
                const values = Object.values(items.toJSON()[key]);

                return (
                  <Fragment key={key}>
                    <tr
                      className={`${this.props.onRowClick ? "enabled" : ""} ${
                        isEqual(this.props.selectedItem, item) ? "selected" : ""
                      }`}
                      onClick={(event) => {
                        if (this.props.scrollIntoView)
                          this.scrollIntoView(event.currentTarget);

                        if (this.props.onRowClick) this.props.onRowClick(item);
                      }}
                    >
                      {values.map((value, key) => {
                        return (
                          <td key={key}>
                            {!this.props.setValue && value.toString()}
                            {this.props.setValue &&
                              this.props.setValue({
                                id: keys[key],
                                value,
                              })}
                          </td>
                        );
                      })}
                    </tr>
                    {isEqual(this.props.selectedItem, item) && (
                      <>
                        <tr className="d-none" key={`${key}1`}>
                          <td colSpan={this.state.totalColumn} />
                        </tr>
                        <tr className="expand" key={`${key}2`}>
                          <td colSpan={this.state.totalColumn}>
                            {this.props.renderSelectedRow &&
                              this.props.renderSelectedRow()}
                          </td>
                        </tr>
                      </>
                    )}
                  </Fragment>
                );
              })}
            <tr>
              <td
                className={`end ${this.props.initiated ? "" : "d-none"} 
                ${this.props.isLoading ? "d-none" : ""}
                ${this.props.listComplete ? "d-none" : ""}`}
                ref={this.endRef}
                colSpan={this.state.totalColumn}
              >
                end
              </td>
            </tr>
            <tr>
              <td className="d-none" colSpan={this.state.totalColumn} />
            </tr>
            {(!items || this.props.isLoading) &&
              !this.props.listComplete &&
              [...Array(10)].map((item, key) => {
                return (
                  <tr key={key}>
                    {[...Array(this.state.totalColumn)].map((subitem, key) => {
                      if (this.props.setSkeleton)
                        return this.props.setSkeleton(key);

                      return (
                        <td key={key}>
                          <span className="dummy">loading</span>
                        </td>
                      );
                    })}
                  </tr>
                );
              })}
          </tbody>

          {this.props.listComplete && !items && (
            <tfoor>
              <tr>
                <td>
                  <div className="text-center">
                    {translations("thereIsNoData")}
                  </div>
                </td>
              </tr>
            </tfoor>
          )}
        </table>
      </div>
    );
  }
}

export default TableList;
